import { ref } from "vue";

export const wecomaKeysReady = ref(false);
